export let markAsRead = "PsqBhe";
export default {markAsRead};